import { createSlice } from '@reduxjs/toolkit'

const sedesSlice = createSlice({
    name: 'sedes',
    initialState: { sedes: []},
    reducers: {
        setSedes(state, action) {
           state.sedes = action.payload
        }
    }
})

export const { setSedes } = sedesSlice.actions
export default sedesSlice.reducer